import { p as promiseResolve, b as bootstrapLazy } from './index-cb7450a3.js';
export { s as setNonce } from './index-cb7450a3.js';

/*
 Stencil Client Patch Esm v2.22.3 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["globalelem-footnote-component",[[1,"globalelem-footnote-component",{"theme":[1537],"moduleId":[1537,"module-id"],"componentId":[1537,"component-id"],"visible":[1540],"headline":[1537],"description":[1537],"goBackLabel":[1537,"go-back-label"],"direction":[32],"footnotes":[32],"activeGoBackId":[32]},[[4,"scrolledFootnote","handleScrolledFootnote"]]]]]], options);
  });
};

export { defineCustomElements };
